import * as React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";

export default function FloatingSearchBar({
  value,
  onChange,
  handleKeyDown,
  handleKeyUp,
  biRef,
  width
}) {
  const ref = React.useRef();

  biRef.focus = () => {
    // console.log("biref.focus", ref)
    ref.current.focus();
    ref.current.select();
  }

  return (
    <Paper
      component="form"
      sx={{
        zIndex: 100,
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: width || 400,
        position: "fixed",
        top: 80,
        right: 20,
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1, maxWidth: width || 400 }}
        placeholder="Search..."
        inputRef={ref}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        inputProps={{ "aria-label": "search google maps" }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}
